<script setup>
import {onMounted, ref, watch} from 'vue'
import {codePreview, formatDate, validatePhoneNumber} from '@/helper';
import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import Textarea from '@/components/forms/Textarea.vue';
import Select from '@/components/forms/Select.vue';
import {authData} from '@/services/AuthService';
import Input from "@/components/forms/Input.vue";
import IntermediaryPersonsService from "@/services/IntermediaryPersonsService";
import {useI18n} from 'vue-i18n';

const {t} = useI18n();

const props = defineProps({
  intermediaryPersonId: {type: Number, required: false},
});

const intermediaryPersonId = ref(null);

const intermediaryPeople = ref([]);

const isOpen = ref(true)
const emit = defineEmits(['confirm', 'cancel']);
const closeModalWith = (value) => {
  setTimeout(() => {
    if (value === 'confirm') {
      emit('confirm', intermediaryPersonId.value);
      isOpen.value = false;
    } else {
      emit('cancel');
      isOpen.value = false;
    }
  }, 300);
}

onMounted(() => {
  fetchIntermediaryPeople();
});

if (props.intermediaryPersonId) {
  intermediaryPersonId.value = props.intermediaryPersonId;
}

function fetchIntermediaryPeople() {
  IntermediaryPersonsService.getAll().then(response => {
    intermediaryPeople.value = response;
  });
}

function openModal() {
  isOpen.value = true
}
</script>

<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div" class="modal show d-block" style="z-index: 1055;">
      <div class="modal-backdrop fade show"></div>
      <div class="modal-dialog modal-dialog-centered modal-lg" style="z-index: 1055">
        <div class="modal-content">
          <DialogPanel class="modal-body p-4 rounded-lg shadow-lg">
            <div class="modal-header">
              <DialogTitle as="h3" class="modal-title">
                {{ t('changeOwnerModal.change_owner') }}
              </DialogTitle>
              <i class="btn-close cursor-pointer" @click="closeModalWith('cancel')" aria-label="Close"></i>
            </div>
            <form @submit.prevent="closeModalWith('confirm')">
              <div class="modal-body">
                <div class="row mb-3">
                  <div class="col-12">
                    <label for="type" class="form-label">{{ t('changeOwnerModal.owner') }}</label>
                    <select v-model="intermediaryPersonId" class="form-select" id="type">
                      <option :key="index" v-for="(intermediaryPerson, index) in intermediaryPeople" :value="intermediaryPerson.id">{{ intermediaryPerson.fullname }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-link text-decoration-underline text-dark" @click="closeModalWith('cancel')">{{ t('changeOwnerModal.cancel') }}</button>
                <button class="btn btn-primary btn-md" type="submit">{{ t('changeOwnerModal.save') }}</button>
              </div>
            </form>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

